import { http } from "./config";
import authHeader from "./auth-header";

export default {
  // Autenticação (opcional, backend pode gerenciar automaticamente)
  authenticate: () => {
    return http.post(
      "/sonax/auth",
      {},
      {
        headers: authHeader(),
      },
    );
  },

  // Buscar templates
  getTemplates: (telefone) => {
    return http.get("/sonax/templates", {
      params: {
        telefone: telefone,
      },
      headers: authHeader(),
    });
  },

  // Enviar mensagem
  sendMessage: (data) => {
    return http.post("/sonax/send-message", data, {
      headers: authHeader(),
    });
  },

  sendMessageFile: ({ protocolo, to, from, file, fileUrl, isAudio = false }) => {
    const formData = new FormData();

    formData.append("protocolo", protocolo);
    formData.append("to", to);
    formData.append("from", from);

    // Adicionar file ou fileUrl dependendo do que foi fornecido
    if (file) {
      formData.append("file", file);
    }
    if (fileUrl) {
      formData.append("fileUrl", fileUrl);
    }
    
    formData.append("isAudio", isAudio);
    console.log(formData);
    return http.post("/sonax/send-message-file", formData, {
      headers: {
        ...authHeader(),
      },
    });
  },

  // Buscar mensagens de um protocolo
  getMessages: (protocolNumber) => {
    return http.get("/sonax/messages", {
      params: {
        protocolNumber: protocolNumber,
      },
      headers: authHeader(),
    });
  },

  // Buscar protocolos em um período
  getProtocols: (dtInicio, dtFim, telefone) => {
    return http.get("/sonax/protocols", {
      params: {
        dtInicio: dtInicio,
        dtFim: dtFim,
        telefone: telefone,
      },
      headers: authHeader(),
    });
  },
  // Buscar protocolos em um período
  getProtocolsByStatus: (
    dtInicio,
    dtFim,
    status,
    telefone,
    empresa,
    idFila = null,
  ) => {
    return http.get("/sonax/protocols-by-status", {
      params: {
        dtInicio: dtInicio,
        dtFim: dtFim,
        status: status,
        telefone: telefone,
        empresa: empresa,
        idFila: idFila,
      },
      headers: authHeader(),
    });
  },

  listarPainelProtocolos: (dtInicio, dtFim, empresa, telefone, protocolo, opcoes = {}) => {
    return http.get("/sonax/painel-protocolos", {
      params: {
        dtInicio,
        dtFim,
        empresa,
        telefone,
        protocolo,
        consultarDivergencia: opcoes.consultarDivergencia ? true : false,
        interacao: opcoes.interacao || "todos",
        ignorarCampanha: opcoes.ignorarCampanha ? true : false,
      },
      headers: authHeader(),
    });
  },

  fecharProtocolosLocal: (protocolNumbers) => {
    return http.post("/sonax/protocol/fechar-local", protocolNumbers, {
      headers: authHeader(),
    });
  },

  // Fechar protocolo
  closeProtocol: (protocolId, protocolNumber, to, from) => {
    return http.post(
      "/sonax/protocol/close",
      {},
      {
        params: {
          protocolId: protocolId,
          to: to,
          from: from,
          protocolNumber: protocolNumber,
        },
        headers: authHeader(),
      },
    );
  },

  // Vincular atendimento ao protocolo
  vincularAtendimento: (protocolNumber) => {
    return http.post(
      `/sonax/protocol/${protocolNumber}/vincular-atendimento`,
      {},
      {
        headers: authHeader(),
      },
    );
  },

  // Desvincular atendimento do protocolo
  desvincularAtendimento: (protocolNumber) => {
    return http.post(
      `/sonax/protocol/${protocolNumber}/desvincular-atendimento`,
      {},
      {
        headers: authHeader(),
      },
    );
  },

  // Buscar contato por telefone
  searchContact: (telefone, from) => {
    return http.get("/sonax/search-contact", {
      params: {
        telefone: telefone,
        from: from,
      },
      headers: authHeader(),
    });
  },

  // Buscar protocolos por telefone
  getProtocolsByPhone: (numeroTelefone, from) => {
    return http.get("/sonax/protocols/by-phone", {
      params: {
        numeroTelefone: numeroTelefone,
        from: from,
      },
      headers: authHeader(),
    });
  },

  // Buscar mensagens por telefone
  getMessagesByPhone: (numeroTelefone, empresa) => {
    console.log(empresa);
    return http.get("/sonax/messages/by-phone", {
      params: {
        numeroTelefone: numeroTelefone,
        empresa: empresa,
      },
      headers: authHeader(),
    });
  },

  getClienteInfo: (valor, tipoBusca) => {
    return http.get("/sonax/info", {
      params: {
        valor: valor,
        tipoBusca: tipoBusca,
      },
      headers: authHeader(),
    });
  },

  // Buscar cliente na API iVertex pelo CPF/CNPJ
  obterClientePorCpf: (cpf) => {
    return http.get("/sonax/ivertx/cliente", {
      params: {
        cpf: cpf,
      },
      headers: authHeader(),
    });
  },

  // Atualizar cliente na API iVertex
  atualizarCliente: (clienteDados) => {
    return http.post("/sonax/ivertx/cliente", clienteDados, {
      headers: authHeader(),
    });
  },

  // Salvar interação do cliente na API iVertex
  salvarInteracaoCliente: ({
    idEntidade,
    tipo,
    nomeContato,
    assunto,
    descricaoInteracao,
  }) => {
    return http.post(
      "/sonax/ivertx/interacao",
      {},
      {
        params: {
          idEntidade,
          tipo,
          nomeContato,
          assunto,
          descricaoInteracao,
        },
        headers: authHeader(),
      },
    );
  },

  // Gerar forma de pagamento
  gerarFormaPagamento: (
    idDocumento,
    telefone,
    from,
    formaPagamento,
    protocolo,
  ) => {
    const params = {};
    if (telefone) params.telefone = telefone;
    if (from) params.from = from;
    if (formaPagamento) params.forma_pagamento = formaPagamento;
    if (protocolo) params.protocolo = protocolo;

    return http.post(
      `/sonax/gerar-forma-pagamento/${idDocumento}`,
      {},
      {
        params: params,
        headers: authHeader(),
      },
    );
  },

  transferirAtendimento: (protocolNumber, novoAtendente) => {
    return http.post(
      `/sonax/protocol/${protocolNumber}/transferir-atendimento`,
      {},
      {
        params: {
          novoAtendente: novoAtendente,
        },
        headers: authHeader(),
      },
    );
  },
  transferirAtendimentoFila: (protocolNumber, novaFila) => {
    return http.post(
      `/sonax/protocol/${protocolNumber}/alterar-fila`,
      {},
      {
        params: {
          idFila: novaFila,
        },
        headers: authHeader(),
      },
    );
  },

  adicionarVisitante: (protocolNumber, visitante) => {
    return http.post(
      `/sonax/protocol/${protocolNumber}/adicionar-visitante`,
      {},
      {
        params: {
          visitante: visitante,
        },
        headers: authHeader(),
      },
    );
  },

  removerVisitante: (protocolNumber) => {
    return http.post(
      `/sonax/protocol/${protocolNumber}/remover-visitante`,
      {},
      {
        headers: authHeader(),
      },
    );
  },

  getInteracoes: (dataInicio, dataFim) => {
    return http.get(`/sonax/interacoes`, {
      params: {
        dataInicio: dataInicio,
        dataFim: dataFim,
      },
      headers: authHeader(),
    });
  },

  getMensagensPadrao: () => {
    return http.get(`/sonax/mensagens-padrao`, {
      headers: authHeader(),
    });
  },

  getMensagemPadraoById: (id) => {
    return http.get(`/sonax/mensagens-padrao/${id}`, {
      headers: authHeader(),
    });
  },

  salvarMensagemPadrao: (dto) => {
    return http.post(`/sonax/mensagens-padrao`, dto, {
      headers: authHeader(),
    });
  },
  preencherParametros(templateNome, telefone) {
    return http.get(`/sonax/parametros/${templateNome}`, {
      params: { telefone: telefone },
      headers: authHeader(),
    });
  },

  listarTemplateParametros: () => {
    return http.get("/sonax/template-parametros", {
      headers: authHeader(),
    });
  },

  obterTemplateParametrosPorId: (id) => {
    return http.get(`/sonax/template-parametros/${id}`, {
      headers: authHeader(),
    });
  },

  salvarTemplateParametros: (payload) => {
    return http.post("/sonax/template-parametros", payload, {
      headers: authHeader(),
    });
  },

  excluirTemplateParametros: (id) => {
    return http.delete(`/sonax/template-parametros/${id}`, {
      headers: authHeader(),
    });
  },

  salvarFilaTemplate: (request) => {
    return http.post("/sonax/fila-template", request, {
      headers: authHeader(),
    });
  },

  // Listar todas as filas template
  listarFilaTemplates: () => {
    return http.get("/sonax/fila-template", {
      headers: authHeader(),
    });
  },
  // Listar todas as filas template
  listarFilaTemplatesEmpresa: (empresa) => {
    return http.get(`/sonax/fila-template/${empresa}`, {
      headers: authHeader(),
    });
  },

  finalizarCampanha(telefoneNumber, campanhaName) {
    return http.post("/sonax/campanha/close-protocolos-por-campanha", null, {
      params: {
        campanhaName: campanhaName,
        telefoneNumber: telefoneNumber,
      },
      headers: authHeader(),
    });
  },

  // Buscar status de leitura de uma mensagem
  // Comentado temporariamente
  /*
  getMessageStatus: (protocolNumber, messageId) => {
    return http.get("/sonax/message/status", {
      params: {
        protocolNumber: protocolNumber,
        messageId: messageId,
      },
      headers: authHeader(),
    });
  },
  */
};
